import { render, staticRenderFns } from "./CurationApplicationComponent.vue?vue&type=template&id=4b6f400e&scoped=true"
import script from "./CurationApplicationComponent.vue?vue&type=script&lang=js"
export * from "./CurationApplicationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f400e",
  null
  
)

export default component.exports